import { Hypothesis, HypothesisResponse } from '@/entities/hypothesis'
import { hypothesisMappers } from '../hypothesis'
export { hypothesisMappers }
export type { Hypothesis, HypothesisResponse }
